<ftr-hearing-section-annotation-form
  [value]="hearingHeader.hearingAnnotation"
  [readOnly]="readOnly()"
  (onValueChanged)="hearingAnnotationChanged($event)"
  (onHearingDeleted)="onHearingDeleted.emit()"
  (onSetHearingToOngoing)="onSetHearingToOngoing.emit()"
></ftr-hearing-section-annotation-form>
